/**
* All units is in pixels
* */

export const DEFAULT_SCROLL_VALUE = -10

export const TOPBANNER_HEIGHT_SCREEN_LARGE = 566
export const TOPBANNER_HEIGHT_SCREEN_MEDIUM = 450
export const TOPBANNER_HEIGHT_SCREEN_SMALL = 272
